function updateSidebarHeight() {
    var topbarHeight = $(".top_wrapper").outerHeight(); // measure including padding/border
    var viewportHeight = $(window).height();
    var sidebarHeight = viewportHeight - topbarHeight;

    $(".side_details").css("height", sidebarHeight + "px");
}

// Toggle menu
$(document).on("click", ".side_info_toggle__icon", function () {
    $(".profile_container").toggleClass("menu_open");
    updateSidebarHeight(); // recalc in case layout changes
});

// Resize behavior
$(window).on("resize", function () {
    if ($(window).width() >= 1500) {
        $(".profile_container").removeClass("menu_open");
    }
    updateSidebarHeight(); // recalc on resize
});

// Initial run
$(document).ready(function () {
    updateSidebarHeight();
});
